import React, { useState , useContext, useEffect } from "react";
import app from "../base";
import { withRouter, Redirect} from "react-router-dom";
import { AuthContext } from "../Auth";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from "../images/logo text.png" 
import Search from "../images/searchEN.png"
import "../App.css"
import "../css/bootstrap.css"
import "../css/styles.css"
import Result from "../images/resultEN.png"
import HW1 from "../images/13.png"
import HW2 from "../images/14.png"
import HW3 from "../images/15.png"
import HW4 from "../images/16.png"
import HW5 from "../images/17.png"
import HW6 from "../images/18.png"
import HW7 from "../images/19.png"
import HW8 from "../images/20.png"
import Danger from "../images/danger.png"


export const Hardware = ({history}) => {
  const { currentUser } = useContext(AuthContext);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [Formstatus, setFormstatus] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  
  const db = app.firestore();
  useEffect (() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };
    window.addEventListener("resize", handleResize);
    const documentRef = db.collection('EIPCAFORM').doc(currentUser.uid);
    documentRef.get().then((doc) => {
      if (doc.exists) {
        let formstatusArray = [];
        formstatusArray.push(doc.data());
        const myStringValue = formstatusArray[0].Form_Result;
        setFormstatus(myStringValue);
        
      } else {
        console.log("No such document!");
        SkipBtn = <p></p>
      }
    }).catch((error) => {
      console.log("Error getting document:", error);
    });
    return () => window.removeEventListener("resize", handleResize);
  })

  let SkipBtn;
  let Text;
  if (Formstatus == "No_Risk"){
    SkipBtn = 
    <a className=" " style={{marginLeft: "70%"}} href="/Hardware">
       
    </a>
    Text =  "หากท่านทราบผลประเมินภายใน 6 เดือนแล้วให้กดข้ามการทำแบบประเมิน"
  } else if (Formstatus == "Low_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "70%"}} href="/Hardware">
       
    </a>
    Text = "หากท่านทราบผลประเมินภายใน 6 เดือนแล้วให้กดข้ามการทำแบบประเมิน"
  } else if (Formstatus == "Medium_Risk") {
    SkipBtn = 
    <a className="" style={{marginLeft: "70%"}} href="/Hardware">
       
    </a>
    Text = "หากท่านทราบผลประเมินภายใน 6 เดือนแล้วให้กดข้ามการทำแบบประเมิน"
  } else if (Formstatus == "High_Risk") {
    SkipBtn = 
    <a className=" " style={{marginLeft: "70%"}} href="/Hardware">
       
    </a>
    Text ="หากท่านทราบผลประเมินภายใน 6 เดือนแล้วให้กดข้ามการทำแบบประเมิน"
  } else {
    SkipBtn = 
    <p></p>
  };
  
  const questions = [
    {
      img: Danger,
      question: "Precautions to consider before starting an examination",
      answer: "yes",
      page: "1/11"
    },
    {
      img: HW1,
      question: "Turn on the device.",
      answer: "yes",
      page: "2/11"
    },
    {
      img: HW2,
      question: "Wait for the device to connect to the Wi-Fi. If the status light is red and the screen displays 'Connecting to Wi-Fi,' please be patient as the device establishes the connection. ",
      answer: "yes",
      page: "3/11"
    },
    {
      img: HW3,
      question: "When the status light turns green and the screen displays 'Ready,' it means the device is ready to use. Please press the button on the side once to proceed.",
      answer: "yes",
      page: "4/11"
    },
    {
      img: HW4,
      question: "Start attaching the electrodes according to their designated positions. The status light should turn yellow, and the screen will display 'Paste electrode.'",
      answer: "yes",
      page: "5/11"
    },
    {
      img: HW7,
      question: "Initiate the first examination by pressing the button on the side once. The status light should turn blue, and the screen will display 'ECG Working.' Please remain still until the status light changes.",
      answer: "yes",
      page: "6/11"
    },
    {
      img: HW5,
      question: "Start attaching the electrodes according to their designated positions. The status light should turn yellow, and the screen will display 'Paste electrode.'",
      answer: "yes",
      page: "7/11"
    },
    {
      img: HW7,
      question: "Initiate the Second examination by pressing the button on the side once. The status light should turn blue, and the screen will display 'ECG Working.' Please remain still until the status light changes.",
      answer: "yes",
      page: "8/11"
    },
    {
      img: HW6,
      question: "Start attaching the electrodes according to their designated positions. The status light should turn yellow, and the screen will display 'Paste electrode.'",
      answer: "yes",
      page: "9/11"
    },
    {
      img: HW7,
      question: "Initiate the Third examination by pressing the button on the side once. The status light should turn blue, and the screen will display 'ECG Working.' Please remain still until the status light changes.",
      answer: "yes",
      page: "10/11"
    },
    {
      img: HW8,
      question: "Success!",
      answer: "yes",
      page: "11/11"
    },
  ];

  const handleAnswer = (answer) => {
    setAnswers([...answers, answer]);
    setCurrentQuestion(currentQuestion + 1);
  };



  const renderQuiz = () => {
    const db = app.firestore();
    const DBref = db.collection("EIPCAFORM").doc(currentUser.uid);
    if (currentQuestion === questions.length) {
      // Quiz completed, show results
      const correctAnswers = answers.filter(
        (answer, index) => answer === questions[index].answer
      );
      

      
      return(
      
      <div>
        
        
        <center>
        
        </center>
        <center>
  <div id="jobPanel" className="filter">
    <div className="basic-3">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Job */}
            <div className="job-container">
              <a style={{textDecoration: "none"}} href="/en/HardwareHistory">
              <img
                className="img6"
                src={Result}
              />
              </a>
            </div>{" "}
            <div className="job-container " >
              <a style={{textDecoration: "none"}} href="/en/SuggestionHospital2">
              <img
                className="img6"
                src={Search}
              />
              </a>
            </div>{" "}
          </div>{" "}
          {/* end of col */}
        </div>{" "}
        {/* end of row */}
      </div>{" "}
      {/* end of container */}
    </div>{" "}
    {/* end of basic-3 */}
  </div>

  </center>
        
        
        
        
      </div>
      
      
      
      );
        

    } else {
      const question = questions[currentQuestion];
      return (
        
        
        <div style={{marginTop: "20px",padding: "30px", borderRadius: "10px"}} className="bg-gray">
            <div>
             {SkipBtn}
            </div>
          <h2>{question.page}</h2>
          <img style={{marginBottom: "3%" , borderRadius: "10px" , width: isMobile ? "100%" : "40%"}} src = {question.img}/>
          <h2>{question.question}</h2>
          <button className="mx-3 btn-solid-lg" onClick={() => handleAnswer("yes")}>Next</button>

        </div>
        
        
        
      );
    }
  };
  



  
  const Signout = () => {
    app.auth().signOut();
    history.push("/");
    window.location.reload(true)
  };

  

// Change file to Field for firestore

  return (
    <>
    <Navbar className="navbar fixed-top navbar-light" expand="lg">
      <Container className="container">
      <Navbar.Brand className="navbar-brand logo-image" href="/en/">
        <img src= {Logo} />
      </Navbar.Brand>
      <Navbar.Toggle
        className="navbar-toggler p-0 border-0 ml-auto mr-3"
        type="button"
        data-toggle="offcanvas"
        aria-controls="basic-navbar-nav"
      />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto">
        
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              Service <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center>
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/">
              News from EIPCA <span className="sr-only">(current)</span>
            </Nav.Link>
          </li>
        </center> 
        <center>
          <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/about">
              About us
            </Nav.Link>
          </li>
        </center>
        
        
        <center>
            <li className="nav-item">
            <Nav.Link class="nav-link" style={{color: "red"}} href="#" onClick={Signout} >Sign out</Nav.Link>
            </li>
        </center>
        <center>
          <li className="nav-item">
            <a className= "mx-3" href="/en/HardwareHistory">
              <img style={{width: "40px", height: "40px"}} src= "https://cdn-icons-png.flaticon.com/512/6522/6522516.png"  />
          </a>
          </li>
        </center>
        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/Hardware">
              TH |
            </Nav.Link>
          </li>
        </center>

        <center>
        <li className="nav-item">
          <Nav.Link className="nav-link" href="/en/Hardware">
              EN
            </Nav.Link>
          </li>
        </center>
         
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>

  <center>  
   {/* Header */}
  <header className="ex-header bg-gray">
    <div className="container">
      <div className="row">
        <div className="col-xl-10 offset-xl-1 my-3">
          <h1>EIPCA Device Manual</h1>
          <h4>Please follow the steps carefully</h4>
        </div>{" "}
        {/* end of col */}
      </div>{" "}
      {/* end of row */}
    </div>{" "}
    {/* end of container */}
  </header>{" "}
    <div>
      
    </div>
    <div>{renderQuiz()}</div>
    
    
</center>

<br/>
<br/>
<br/>
<br/>
      
    </>
  );
};

export default withRouter(Hardware);


